export const meses = [
    { value: '01', label: 'Enero'},
    { value: '02', label: 'Febrero' },
    { value: '03', label: 'Marzo' },
    { value: '04', label: 'Abril'},
    { value: '05', label: 'Mayo'},
    { value: '06', label: 'Junio' },
    { value: '07', label: 'Julio' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Septiembre' },
    { value: '10', label: 'Octubre' },
    { value: '11', label: 'Noviembre' },
    { value: '12', label: 'Diciembre' },

 
]

export const documentos = [
    { value: 'Contrato', label: 'Contrato' },
    { value: 'Anexo', label: 'Anexo' },
    { value: 'Liquidación', label: 'Liquidación' },
    { value: 'Otros Documentos', label: 'Otros Documentos' }
  ]



  var dateObj = new Date();
  var year = dateObj.getUTCFullYear();
  
  export const years = [
      { value: year, label: year},
      { value: year-1, label: year-1},
      { value: year-2, label: year-2}
  ]
    


export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


export const isValidEmail = (email) => {
    return emailRegex.test(email);
};